import { ReactNode } from 'react';
import { SelectChangeEvent, MenuItem } from '@mui/material';

import {
  OutlinedInputStyled,
  PlaceholderStyled,
} from 'theSource/components/Input';
import { ExpandMoreIconStyled, SelectStyled } from './SelectStyled';

export interface SelectOption {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface SelectProps {
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  id: string;
  label?: string;
  labelId?: string;
  name?: string;
  onChange?: (event: SelectChangeEvent, child?: ReactNode) => void;
  options: SelectOption[];
  value?: string;
}

const MENU_PROPS = {
  disablePortal: true,
};

const isPlaceholder = (value: string, label: string) => {
  if (value.length > 0) {
    return label;
  }
  return <PlaceholderStyled>{label}</PlaceholderStyled>;
};

export const Select = ({ options, id, ...props }: SelectProps) => (
  <SelectStyled
    data-testid="select-wrapper"
    displayEmpty
    IconComponent={ExpandMoreIconStyled}
    input={<OutlinedInputStyled />}
    inputProps={{ 'data-testid': 'select-input', id: id }}
    MenuProps={MENU_PROPS}
    {...props}
  >
    {options.map(({ label, value, disabled = false }) => (
      <MenuItem key={value} value={value} disabled={disabled}>
        {isPlaceholder(value, label)}
      </MenuItem>
    ))}
  </SelectStyled>
);
